<template>
  <div class="custom-style-page">
    <span>Liên lưu</span>
    <div class="flex items-center flex-col mt-4">
      <h1 class="font-bold">
        TRUNG TÂM MUA BÁN - SỬA - CHỮA - ĐTDĐ - LÊ PHONG MOBILE
      </h1>
      <span
        ><strong>ĐC</strong>: Số 38. Đường Nguyễn Thị Minh Khai – TP.Vinh – Tỉnh
        Nghệ An.</span
      >
      <strong
        >(Ngày nhận {{ receiveDate }} – ngày dự kiến trả
        {{ fixedPlanDate }})</strong
      >
      <div class="w-full">
        <ul class="pl-0 leading-5">
          <li>
            <div class="custom-li">
              <p class="flex">
                <strong>Tên sản phẩm: </strong>
                <span class="flex-grow text-center">{{ productName }}</span>
              </p>
              <p class="flex">
                <span class="w-1/2"
                  ><strong>MSP: </strong>{{ productIMEI }}</span
                >
                <span class="w-1/2"
                  ><strong>MK: </strong>{{ productLockScreen }}</span
                >
              </p>
            </div>
          </li>
          <li>
            <div class="custom-li">
              <span class="flex">
                <strong>Tên khách hàng: </strong>
                <span class="flex-grow text-center">{{ customerName }}</span>
              </span>
              <span class="flex"
                ><strong>SĐT: </strong>{{ customerPhone }}</span
              >
            </div>
          </li>
          <li>
            <div class="custom-li">
              <span class="flex">
                <strong>Tình Trạng Tiếp Nhận : </strong>
                <span class="flex-grow text-center">{{ receiveStatus }}</span>
              </span>
              <span class="flex" />
            </div>
          </li>
          <li>
            <div class="custom-li">
              <span class="flex">
                <span class="flex">
                  <strong>Kỹ thuật viên đảm nhận : </strong>
                  <span class="flex-grow text-center">{{ technicianId }}</span>
                </span>
              </span>
            </div>
          </li>
          <li>
            <div class="custom-li">
              <span class="flex">
                <strong>Nội dung sửa chữa : </strong>
                <span class="flex-grow text-center">{{ fixContent }}</span>
              </span>
              <span class="flex" />
            </div>
          </li>
          <li>
            <div class="custom-li">
              <span class="flex">
                <strong>Báo giá :</strong>
                <span class="flex-grow text-center"
                  ><strong>{{ fixPrice }}</strong></span
                >
              </span>
              <span class="flex">
                <span><strong>Bảo hành : </strong>{{ guarrantyDateName }}</span>
              </span>
            </div>
          </li>
        </ul>
      </div>
      <div class="w-full not-print-content">
        <!-- <p class="underline"><strong>Lưu ý:</strong></p>
        <ul class="custom-type pl-0">
          <li>
            Quá trình sửa chữa có vấn đề gì không hài lòng Quý Khách vui lòng
            liên hệ trực tiếp với kỹ thuật viên đảm nhận để được tư vấn.
          </li>
          <li>
            Phiếu tiếp nhận sửa chữa tương đương với phiếu bảo hành. Không giải
            quyết trong trường hợp mất phiếu.
          </li>
          <li>
            Trung tâm không chịu trách nhiệm với máy bị va đập, rơi nước hoặc
            không có tem của Lê Phong Mobile trong thời gian bảo hành.
          </li>
          <li>
            Quá trình phục vụ không hài lòng Quý khách liên hệ khiếu nại theo số
            :
            <strong>0901.522.225</strong> để được giải đáp thắc mắc.
          </li>
        </ul> -->

        <WarrantyAdditionEditor
          :content="additionContentEditor"
          @update:addition="updateAddition"
        />
      </div>
    </div>
    <div
      v-html="contentPrinted"
      class="print-content el-tiptap-editor__content custom-border-tiptap"
    />
  </div>
</template>

<script>
import WarrantyAdditionEditor from "./WarrantyAdditionEditor.vue";
import { REPAIR_FORM_ADDITION_TEMPLATE } from "~/utils/warrantyAdditionTemplate.js";

export default {
  name: "PhieuSuaChuaForm",
  components: {
    WarrantyAdditionEditor,
  },
  props: {},

  data() {
    return {
      isLoading: false,
      receiveDate: null,
      fixedPlanDate: null,
      productName: null,
      productIMEI: null,
      productLockScreen: null,
      customerName: null,
      customerPhone: null,
      receiveStatus: null,
      technicianId: null,
      fixContent: null,
      fixPrice: null,
      guarrantyDateName: null,
      additionContentEditor: null,
    };
  },
  computed: {
    contentPrinted() {
      return this.additionContentEditor;
    },
  },

  async created() {
    try {
      this.isLoading = true;
      const { phonfixid } = this.$route.params;
      const data = await this.$services.phonefixService.getPhoneFix(phonfixid);

      if (data) {
        this.receiveDate = data?.receiveDate;
        this.fixedPlanDate = data?.fixedPlanDate;
        this.productName = data?.productName;
        this.productIMEI = data?.productIMEI;
        this.productLockScreen = data?.productLockScreen;
        this.customerName = data?.customerName;
        this.customerPhone = data?.customerPhone;
        this.receiveStatus = data?.receiveStatus;
        this.technicianId = data?.technicianId;
        this.fixContent = data?.fixContent;
        this.fixPrice = data?.priceFixFormat;
        this.guarrantyDateName = data?.guarrantyDateName;
      }
      this.additionContentEditor = localStorage.getItem(
        "le-phong-mobile-repair-form-addition-editor"
      );

      if (!this.additionContentEditor) {
        this.additionContentEditor = REPAIR_FORM_ADDITION_TEMPLATE;
      }
    } catch (err) {
      console.log(err);
    } finally {
      this.isLoading = false;
      this.activate();
    }
  },

  methods: {
    updateAddition(value) {
      this.additionContentEditor = value;
      localStorage.setItem(
        "le-phong-mobile-repair-form-addition-editor",
        this.additionContentEditor
      );
    },
    activate() {
      setTimeout(() => window.print(), 1000);
    },
  },
};
</script>

<style style type="scss" media="print" scoped>
.custom-style-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 15px;
  font-family: "Times New Roman", Times, serif;
}

.print-content {
  display: none;
}

.custom-li {
  display: flex;
  /* justify-content: space-between; */
  width: calc(100% - 22px);
  float: right;
  clear: right;
}

ul {
  list-style-type: square;
  list-style: inside;
}

.custom-type {
  list-style-type: disc;
  list-style: inside;
}

.v-application p {
  margin: 0;
}

@media print {
  /* @page {
    size: a5 landscape;
    margin-top: 9%;
  } */

  .custom-style-page {
    display: block;
  }

  .not-print-content {
    display: none;
  }

  .print-content {
    display: block;
  }
  .custom-style-page {
    padding: 0;
  }
}
</style>
